import moment from 'moment';

class OrderHistoryTimeframeController {

    constructor($window, moneyService, userService, messageService, urlService) {
        this.$window = $window;
        this.moneyService = moneyService;
        this.userService = userService;
        this.messageService = messageService;
        this.urlService = urlService;
    }

    $onInit () {
        this.openOrders = [];
        this.sentEmails = [];
    }

    hasOrders () {
        return !!(this.orders && this.orders.data && this.orders.data.length);
    }

    formatDate (date, removeDay = false) {
        if (date) {
            if (date.length === 10) {
                date += ' 00:00:00';
            }

            let format = 'dddd Do MMMM, YYYY';
            if (removeDay) {
                format = 'Do MMMM, YYYY';
            }

            return moment(`${date}+00:00`).format(format);
        }
    }

    formatDateShort (date) {
        if (date) {
            if (date.length === 10) {
                date += ' 00:00:00';
            }
            return moment(`${date}+00:00`).format('D.M.YYYY');
        }
    }

    toggleOrder (orderReference) {
        const index = this.openOrders.indexOf(orderReference);
        if (index > -1) {
            this.openOrders.splice(index, 1);
            return;
        }

        this.openOrders.push(orderReference);
    }

    isOrderOpen (orderReference) {
        return this.openOrders.indexOf(orderReference) > -1;
    }

    sendInvoice (order) {
        this.loading = true;

        return this.userService.emailInvoice(order.basket_identity_code)
            .then(() => {
                this.sentEmails.push(order.order_reference);
                this.messageService.add(`A sales invoice has been emailed for ${order.order_reference}`);
                this.messageService.success();
            })
            .catch(() => {
                this.messageService.add('Failed to send the email. Please try again or contact us');
                this.messageService.failure();
            })
            .then(() => {
                this.loading = false;
            });
    }

    emailSent (orderReference) {
        return !!(this.loading || this.sentEmails.indexOf(orderReference) > -1);
    }

    displayTotal (order) {
        const refundTotal = this.sumArray(order.refund);
        if (refundTotal > 0) {
            return this.displayPrice(order.total - refundTotal, order.currency_code);
        }
        return this.displayPrice(order.total, order.currency_code);
    }

    displayPrice (price, currencyCode) {
        return this.moneyService.reduce(price, currencyCode);
    }

    displayRefundValue (order) {
        const refundTotal = this.sumArray(order.refund);
        return this.displayPrice(refundTotal, order.currency_code);
    }

    sumArray (array) {
        if (array && array.length) {
            return array.reduce((a, b) => a + b, 0);
        }
        return 0;
    }

    orderHasDiscounts (order) {
        return !!(this.isOrderOpen(order.order_reference) &&
            (order.promo_details || order.vouchers.length || order.refund.length));
    }

    orderHasAgreement (order) {
        return !!(this.isOrderOpen(order.order_reference) &&
            this.timeframe === 'upcoming' &&
            order.cancellation_agreement);
    }

    getUrlAndGo (item) {
        return this.urlService.getUrl(item.item_type, item.item_id)
            .then(response => {
                this.$window.location = response;
            })
            .catch(() => { });
    }
}

OrderHistoryTimeframeController.$inject = ['$window', 'moneyService', 'userService', 'messageService', 'urlService'];

export default OrderHistoryTimeframeController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/controllers/order.history.timeframe.controller.js